import React, { useEffect, useState, CSSProperties } from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import Button from '../button/button';
import classNames from 'classnames';
import _noop from 'lodash/noop';

interface Props {
	label: string;
	minValue?: number;
	maxValue?: number;
	defaultValue?: number;
	onChange?: (value: number) => void;
	value?: number;
	disabled?: boolean;
	style?: CSSProperties;
	className?: string;
}

const LabelNumberInput: React.FC<Props> = ({
	label,
	maxValue = Infinity,
	minValue = -Infinity,
	defaultValue,
	onChange = _noop,
	value,
	disabled = false,
	style,
	className
}) => {
	const [componentValue, setComponentValue] = useState<number>(value || defaultValue || 0);

	useEffect(() => {
		if (value !== undefined) {
			setComponentValue(value || 0);
		}
	}, [value]);

	const handleChangeValue = (newValue: number) => {
		const valueToUpdate = newValue < minValue ? minValue : newValue > maxValue ? maxValue : newValue;
		if (value === undefined) {
			setComponentValue(valueToUpdate);
		}

		onChange(valueToUpdate);
	};

	const handleDecrease = () => {
		handleChangeValue(componentValue - 1);
	};

	const handleIncrease = () => {
		handleChangeValue(componentValue + 1);
	};

	return (
		<div className={classNames('label-number-input', className)} style={style}>
			<Button
				className={`input-button ${disabled ? 'angles-disabled' : 'angles'}`}
				disabled={disabled || minValue >= componentValue}
				onClick={handleDecrease}
			>
				<BringgIcon iconName={BringgFontIcons.Chevron} className="angle-icon" />
			</Button>
			<div className={`${disabled ? 'label-number-input-text-disabled' : 'label-number-input-text'}`}>
				{`${componentValue} ${label}`}
			</div>
			<Button
				className={`input-button ${disabled ? 'angles-disabled' : 'angles'}`}
				disabled={disabled || maxValue <= componentValue}
				onClick={handleIncrease}
			>
				<BringgIcon iconName={BringgFontIcons.ChevronUp} className="angle-icon" />
			</Button>
		</div>
	);
};

export default LabelNumberInput;
